/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */


	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.TabNavigationContent = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			mod.url = mod.$ctx.data('url');
			if (window.location.href.indexOf('wcmmode=disabled') > 0) {
				mod.url = SCS.portal.addParamToUrl(mod.url, 'wcmmode', 'disabled');
			}
			if (!mod.$ctx.data('lazy-loading-enabled')) {
				mod.$ctx.addClass('loaded');
			}
			mod.loadingIndicator = $('<div>').addClass('loading-indicator');
			mod.errorMessage = mod.$ctx.find('.tab-content-error').first();
			mod.onStartSubscription();
			callback();
		},

		onStartSubscription: function() {
			var mod = this,
				initialChannel = 'TabNavigation',
				productDataHubChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribe', {
				element: mod.$ctx,
				type: 'content',
				name: mod.$ctx.data('name'),
				index: mod.$ctx.data('index'),
				isActive: mod.$ctx.hasClass('active'),
				subscribe: function(channel, name, index) {
					mod.navigationChannel = channel;
					mod.name = name;
					mod.index = index;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);
					mod.$ctx.on('activate', function(event){
						if (!mod.$ctx.hasClass('active')) {
							mod.fire('activateContent', {
								index: index,
								name: name
							}, [channel]);
							event.stopPropagation();
							event.stopImmediatePropagation();
						}
					});
				}
			}, [initialChannel]);
		},

		onActivateTab: function(data) {
			var mod = this;
			if(!mod.$ctx.parent().is(":visible"))
				return;
			if (data.index === mod.index) {
				mod.showContent();
			} else {
				mod.hideContent();
			}
		},

		showContent: function() {
			var mod = this;
			this.loadingIndicator.detach();
			this.$ctx.addClass('active');
			this.$ctx.closest('.tabcontent').addClass('active');
			if (!this.$ctx.hasClass('loaded')) {
				this.loadContent();
				this.$ctx.trigger('show');
				SCS.utils.initNewModules(this.$ctx);
			} else {
				SCS.utils.initNewModules(this.$ctx);
				mod.fireContentDisplayedEvent();
				this.$ctx.trigger('show');
			}
			$(document).trigger('element-shown', [this.$ctx]);
		},

		hideContent: function() {
			var mod = this;
			if (mod.navigationChannel) {
				mod.$ctx.removeClass('active');
				mod.$ctx.closest('.tabcontent').removeClass('active');
				mod.$ctx.addClass('hideEditbar').trigger('hide');
			}
		},

		loadContent: function() {
			var mod = this;
			if (!this.$ctx.hasClass('loading')) {
				this.$ctx.addClass('loading');
				if (this.url) {
					this.errorMessage.addClass('hidden');
					this.$ctx.prepend(mod.loadingIndicator);
					$.ajax({
						type: 'GET',
						url: mod.url,
						success: $.proxy(mod.onLoadContentSuccess, mod),
						error: $.proxy(mod.onLoadContentError, mod)
					});
				} else {
					this.$ctx.removeClass('loading');
					this.$ctx.addClass('loaded');
				}
			}
		},

		onLoadContentError: function() {
			this.loadingIndicator.detach();
			this.$ctx.removeClass('loading');
			this.errorMessage.removeClass('hidden');
		},

		onLoadContentSuccess: function(htmlContent) {
			this.$ctx.removeClass('loading');
			this.$ctx.addClass('loaded');
			this.loadingIndicator.detach();
			this.$ctx.html(htmlContent);
			if (this.tabTitle) {
				this.$ctx.prepend(this.tabTitle);
			}
			SCS.utils.initNewModules(this.$ctx);
			this.$ctx.trigger('create');
			this.fireContentDisplayedEvent();
		},

		fireContentDisplayedEvent: function() {
			var mod = this;
			if (mod.navigationChannel) {
				this.fire('visibleContentChanged', {
					content: mod.$ctx
				}, [mod.navigationChannel]);
			}
		}
	});

}(Tc.$, window.SCS));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigationContent.js
// module id = 190
// module chunks = 0